import React from 'react';
import ReactDOM from 'react-dom';
import screenfull from 'screenfull';

import App from 'components/App';
import registerServiceWorker, {
  unregister as unregisterServiceWorker,
} from './registerServiceWorker';

import 'init/firebase';

import 'styles/index.scss';
import 'animate.css';

ReactDOM.render(
  <App />,
  document.getElementById('app-root')
);

const domainsToUnregister = [
  'itggot.info',
  'www.itggot.info',
  'itggot.space',
  'www.itggot.space',
  'itggot.online',
  'www.itggot.online',
];

if (domainsToUnregister.includes(window.location.hostname)) {
  unregisterServiceWorker();
} else {
  registerServiceWorker();
}

if (screenfull.enabled) {
	document.onkeyup = (event) => {
		if (event.keyCode === 13) {
      event.preventDefault();
      screenfull.toggle();
		}
	}
}



// WEBPACK FOOTER //
// ./src/index.js